import { Pipe, PipeTransform } from '@angular/core';

import { FeatureFlagValue } from 'app/feature-toggle-list';
import { FeatureToggleService } from 'app/shared/services/feature-toggle.service';

//

@Pipe({ name: 'featureFlag' })
export class FeatureFlagPipe implements PipeTransform {
  constructor(private _feature :FeatureToggleService) {}

  transform(flag :FeatureFlagValue | FeatureFlagValue[]) :boolean {
    if (Array.isArray(flag)) {
      // check all feature flag and all must be true
      return flag.every((f) => this._feature.isActive(f));
    }

    return this._feature.isActive(flag);
  }
}
